module.exports = __webpack_public_path__ + "assets/word_bonus_default.f3d47e38.svg";